<style lang="less">
  @import "./css/common.less";
</style>
<template>
  <div class="about-us common-content">
    <navMenu></navMenu>
    <div class="content">
      <div class="banner-items">
        <img src="../assets/images/banner_ABOUTUS.jpg">
        <div class="banner-title font-large">
          <span>ABOUT US</span>
        </div>
      </div>
      <div class="text-content">
        <div class="pc-items">
          <ContactBox></ContactBox>
        </div>
        <div class="article">
          <div class="bread-crumbs">
            <span class="pointer" @click="goToIndex">HOME></span>
            <span>ABOUT US</span>
          </div>
          <span class="article-title">LAKE TAI APPAREL PTY LTD</span>
          <div class="article-content">
            <p>
              We are fabric and garment supplier. Our production base is located in WuXi of China, near shanghai.  We have fabric and garment manufacture factory there. We have production team and warehousing facility in Australia and China.
            </p>
            <p>
              We have long years of fabric and garment production experience, plenty of quality fabric and garment are supplied to Australia and New Zealand market in the past two decades.
            </p>
            <p>
              Our commitment is reflected in our passion to build strong relationships with our customers based on trust, confidence and dependability, as well as provide top quality fabric and clothing at competitive pricing, never compromising on service. Our goal is to respond to our customers needs to the very best of our ability.
            </p>
            <p>
              We pride ourselves on timely deliveries, as we are the manufacturer, we have the ability to process small production runs to replenish stock with minimal delay. We can respond to small top-up orders and special requests.
            </p>
            <p>
              We honor all the orders, whatever big or small, our experienced and knowledgeable team can help you to create more value. behind you, move forward together.
            </p>
            <p>
              Here are Lake Tai Apparel, fabric and garment total solution.
            </p>
          </div>
        </div>
        <div class="mb-items">
          <ContactBox></ContactBox>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import NavMenu from '../components/navMenu'
import Footer from '../components/footer'
import ContactBox from '../components/contactBox'
export default {
  data () {
    return {
      // url: ''
    }
  },
  components: {
    NavMenu,
    Footer,
    ContactBox
  },
  methods: {
    goToIndex(){
      this.$router.push('/index')
    }
  },
  watch: {},
  mounted () {
    // console.log(this.$route.path)
    // let url = this.$route.path.split('/')[1]
    // this.url = url.toUpperCase()
  }
}
</script>
<style lang="less">
  .about-us{
    
  }
</style>
